module.exports = __webpack_public_path__ + "img/蒙版组 186.43f18282.svg";